import React, { useState, useEffect,  useRef } from "react";
import { CTX } from "../components/Store";
import { valDt, valDt2 } from './util';
import { v4 as uuidv4 } from 'uuid';
import 'bootstrap/dist/css/bootstrap.css';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import './Moon.css';

const vidsSpirit = [
'gDZG2nYwK60','YNL4rVSw0O8','bn1LrhaXo0M','_2U1thTI89s',
'fn4tX8JxIGc','FzwoWByaZa4','8XKiTF6m8XA',
'pM-KQm8ybwc','pzGFZ9tqNlQ','wFPpQr4qKgU',
'eKPNq1d9vSo','DQW57muy5iE','XvDer5Lyd7s',
'uszvyK25SYs','L7tOncrdrCI','HczzQHgbLZ4',
'dlV4kzTTZVk','IpOyDBoQme0','sTQ-KwbXrS0',
'Ch7HVp3fkvY','Bd_grMp7X6o','43u8fTxZRHo',
'61jnHmXQVDQ','B7_cyfJ8Mvc','Xl44f4GFQgk',
'qWutnOebRTw','WGe6iJhEd9s','z_U4sRhH-ls',
'9ZNxNbykA3I'
];

const vidsWizard = [
  'eAfAVVfwWG8', 'ENk68sTiYTQ', 'K3SSKLhc2V8', 'FUBwdJNA6WA', 'bje-j7VMzYM', 'LaRAf5_yFs8',
  '9dpLHig3iZo', '9NZnixPehOM', '8fQSFH0dLIg', 'Z1VMYDuWbW8', 'pLXsjJ_FYuU', 'GFzhO8E2Z7Y',
  '0MBW8xDs9FA', 'Od9MGiVlwW4', 'gR8LSrtSy_8', 'I4tRLE7Ta8I', 'If1G1ptlgFo', '8hSHN3AMq-Q',
  'PzU4hQocAh0', 'T7s8xtX4wYc', 'yTV_bTFv534',
  '74OnFXjQ1bc', '_oYDBB0J7fw', 'HKFcF90ZMWA',
  'fx_0b8NoK4g',  'QXnzC6bhoJU', 'k4isQBrzkTQ',
  '36oe6bFoH94', '9F-ffN-dZac'
];

const vidsInsta = [
'DdeKuS8iYu-/','DdNFXxaCfXX','DdZy2rCqxc8','DdZ4QGwiqYd/',
'DdZ6PD4i1GT','DdeuUeuCoLN/','DdevNV2K0eE/','Ddev5sFqPgj/',
'DdexBA5CIMc/','DdexlMWiE85/','DdeyWyZKs6O/','Ddey6-FC-WI/',
'Ddezx7aKG5G/','Dde1Hz8CzTY/','Dde1rblq57e/','Dde2HYrqgRR/',
'Dde3KGRCUmG/','Dde3tlli5W0/','Dde4OOdiRYp/','Dde4zTNCfiK/',
'Dde5UarCXuv/','Dde51hGi6D8/','Dde6XNZC37L/','Dde6tKMqpbu/',
'Dde7M07iNz7/','Dde7zK3KW3F/','Dde8WCXCgsP/','Dde8y_IK5Xq/',
'Dde9SFMqI8Y/'
];

const vidsTikTok = [
'7686617144548707598','7686615937075793166','7686616435874991374','7686623683112209678',
'7686624326279351566','7686624995203697933','7686625583526104333','7686626118367038734',
'7686627138547551502','7686628216768875790','7686628825274322190','7686631614243294477',
'7687697504715984141','7687698200081272077','7687698746070617357','7687699223684402446',
'7687700072288636173','7687700831063362830','7687701633605668110','7687702325162478861',
'7687703234399472909','7687703958613216525','7687704482049805582','7687705214585015565',
'7687705978459999501','7687706937022024973','7687707501491490061','7687708239684848909',
'7687708928448285966'
];

export default function Moon() {
  const { st, sendReq } = React.useContext(CTX);
  const [, updateComponent] = React.useState();
  const forceUpdateComponent = React.useCallback(() => updateComponent({}), [])
  const NOT_FOUND = -999;

  const eform = React.createRef(null);
  const bdate = React.createRef(null);
  const btime = React.createRef(null);
  const [city, setCity] = useState("");
  const [stctry, setStctry] = useState("");
  const [lmt, setLmt] = useState("");
  const [jcal, setJcal] = useState("");
  const [blong, setBlong] = useState("");
  const [blat, setBlat] = useState("");
  const [gmtoff, setGmtoff] = useState("");
  const [message, setMessage] = useState("");

  const [n_moon_phase, set_n_moon_phase] = useState(null);
  const [n_moon_interp, set_n_moon_interp] = useState("");
  const [n_moon_summ, set_n_moon_summ] = useState("");
  const [p_moon_phase, set_p_moon_phase] = useState(null);
  const [p_moon_interp, set_p_moon_interp] = useState("");
  const [p_moon_summ, set_p_moon_summ] = useState("");
  const [n_moon_title, set_n_moon_title] = useState("");
  const [p_moon_title, set_p_moon_title] = useState("");
  const [n_sun_interp, set_n_sun_interp] = useState("");
  const [n_sun_summ, set_n_sun_summ] = useState("");
  const [p_sun_interp, set_p_sun_interp] = useState("");
  const [p_sun_summ, set_p_sun_summ] = useState("");
  const [n_sun_title, set_n_sun_title] = useState("");
  const [p_sun_title, set_p_sun_title] = useState("");
  const [seltab, setSeltab] = useState('');

  const path = window.location.pathname;

  // 2. Get the parameters ("?parameter01")
  const searchParams = window.location.search;

//  console.log(`Path is: ${path}`);         // Outputs: /moon
//  console.log(`Parameter is: ${searchParams}`); // Outputs: ?parameter01

  useEffect(() => {
    set_n_moon_phase(null);
    set_n_moon_interp("");
    set_n_moon_summ("");
    set_p_moon_phase(null);
    set_p_moon_interp("");
    set_p_moon_summ("");
    set_n_sun_interp("");
    set_n_sun_summ("");
    set_p_sun_interp("");
    set_p_sun_summ("");
    set_n_moon_title('');
    set_p_moon_title('');
    set_n_sun_title('');
    set_p_sun_title('');
    setSeltab('');
    setMessage('');

    const req = "mpinit";
    sendReq({ msg: req });

    return() => {
      set_n_moon_phase(null);
      set_n_moon_interp("");
      set_n_moon_summ("");
      set_p_moon_phase(null);
      set_p_moon_interp("");
      set_p_moon_summ("");
      set_n_sun_interp("");
      set_n_sun_summ("");
      set_p_sun_interp("");
      set_p_sun_summ("");
      set_n_moon_title('');
      set_p_moon_title('');
      set_n_sun_title('');
      set_p_sun_title('');
      setSeltab('');
      setMessage('');
      st.lltzone={};
    };
    forceUpdateComponent();
  }, []);

  useEffect(() => {
    const NOT_FOUND = -999;
    set_n_moon_phase(null);
    set_n_moon_interp("");
    set_n_moon_summ("");
    set_p_moon_phase(null);
    set_p_moon_interp("");
    set_p_moon_summ("");
    set_n_sun_interp("");
    set_n_sun_summ("");
    set_p_sun_interp("");
    set_p_sun_summ("");
    set_n_moon_title('');
    set_p_moon_title('');
    set_n_sun_title('');
    set_p_sun_title('');
    setSeltab('');

    if( Object.keys(st.lltzone).length === 0 && st.lltzone.constructor === Object) {
    } else {
      let lng = st.lltzone.lng;
      let lat = st.lltzone.lat;
      let gmt_off = fmtTz(st.lltzone.tz);
      let msg = '';
      if (lng === NOT_FOUND) {
          lng = 0.0;
          lat = 0.0;
          gmt_off = 0.0;
          msg = 'Location not found';
          st.lltzone = {};
        } else {
          if (gmt_off === NOT_FOUND) {
            msg = 'GMT Offset not found. LMT?';
          }
        }
        setBlong(lng);
        setBlat(lat);
        setGmtoff(gmt_off);
        setMessage(msg);
        st.lltzone = {};
      }
    }, [st.lltzone]);

  useEffect(() => {
    if (st.n_moon_phase) {
      let natal28 = st.n_moon_phase.substring(1);
      let prog28 = st.p_moon_phase.substring(1);
      //console.log("Natal Moon=", st.n_moon_phase);
      //console.log(`Parameter is: ${searchParams}`); // Outputs: ?parameter01

      if (searchParams.toLowerCase().includes("spirit")) {
      //   console.log("Found the match (ignoring case)!");
         openYouTubeVideo(vidsSpirit[st.n_moon_phase]);
      }
      if (searchParams.toLowerCase().includes("wizard")) {
      //   console.log("Found the match (ignoring case)!");
         openYouTubeVideo(vidsWizard[st.n_moon_phase]);
      }
      if (searchParams.toLowerCase().includes("insta")) {
      //   console.log("Found the match (ignoring case)!");
         openInstaVideo(vidsInsta[st.n_moon_phase]);
      }
      if (searchParams.toLowerCase().includes("tiktok")) {
      //  console.log("Found tiktoc match ", st.n_moon_phase, "->",vidsTikTok[st.n_moon_phase]);
         openTikTokVideo(vidsTikTok[st.n_moon_phase]);
      }
      setSeltab("tab1");
      // jjh use moon title to hold onto moon_phase
      set_n_moon_title(st.n_moon_phase);
      set_p_moon_title("Progressed Moon " + prog28);
      set_n_moon_interp(st.n_moon_interp);
      set_n_moon_summ(st.n_moon_summ);
      set_p_moon_phase(st.p_moon_phase);
      set_p_moon_interp(st.p_moon_interp);
      set_p_moon_summ(st.p_moon_summ);
      set_n_sun_interp(st.n_sun_interp);
      set_n_sun_summ(st.n_sun_summ);
      set_n_sun_title(st.n_sun_title);
      set_p_sun_interp(st.p_sun_interp);
      set_p_sun_summ(st.p_sun_summ);
      set_p_sun_title(st.p_sun_title);
    } else {
      set_n_moon_phase(null);
      set_n_moon_interp("");
      set_n_moon_summ("");
      set_p_moon_phase(null);
      set_p_moon_interp("");
      set_p_moon_summ("");
      set_n_sun_interp("");
      set_n_sun_summ("");
      set_p_sun_interp("");
      set_p_sun_summ("");
      set_n_moon_title('');
      set_p_moon_title('');
      set_n_sun_title('');
      set_p_sun_title('');
      setSeltab('');
      setMessage('');
      }
    }, [st.n_moon_phase]);
/*
  const fmtDttm = (bdt, btm) => {
    let dt = valDt2(bdt + 'T' + btm);
    if (dt === '') {
      return '';
    }
    const tm = btm.split(':');
    let tmhr = parseInt(tm[0]);
    let ampm = 'AM';
    if (tmhr > 12) {
      tmhr -= 12;
      ampm = 'PM';
    }
    return(`${dt} ${tmhr}:${tm[1]}:00 ${ampm}`);
  }

  const fmtDttm2 = (bdt, btm) => {
    let dt = valDt2(bdt + 'T' + btm);
    if (dt === '') {
      return '';
    }
    const tm = btm.split(':');
    return(`${dt} ${tm[0]}:${tm[1]}:00`);
  }
*/

  const fmtDttm3 = (bdt, btm) => {
    let dt = valDt(bdt + 'T' + btm);
    if (dt === '') {
      return '';
    }
    const tm = btm.split(':');
    let tmhr = parseInt(tm[0]);
    let ampm = 'AM';
    if (tmhr > 12) {
      tmhr -= 12;
      ampm = 'PM';
    }
    return(`${dt} ${tmhr}:${tm[1]}:00 ${ampm}`);
  }
  const titleCase = (str) => {
    var splitStr = str.toLowerCase().split(' ');
    for (var i = 0; i < splitStr.length; i++) {
      splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    return splitStr.join(' ');
  }

  const fmtTz = (tz) => {
    let tz2 = tz.toString();
    if (tz2.indexOf(".") === -1) {
      tz2 = tz2 + '.0';
    }
    return parseFloat(tz2);
  }

  const onBlur = (e) => {
    e.preventDefault();

    if ((e.target.name === 'stctry' ||
      e.target.name === 'city' ||
      e.target.name === 'bdate' ||
      e.target.name === 'btime' ) &&
      (stctry.length > 0 &&  city.length > 0 && bdate.current.value.length > 0 &&  btime.current.value.length > 0 )) {
      const dttm = fmtDttm3(bdate.current.value, btime.current.value);
      if (dttm === ''){
        setMessage('Invalid Date');
        return;
      }
      const cityst = `${city} ${stctry}`;
      const req = `"{"event":"lltzone-req","data":" { 'cityst': '${cityst}', 'dttm': '${dttm}'}"}"`;
      sendReq({ msg: req });
      setMessage('');
    }
  };


  const openYouTubeVideo = (mphase) => {
    //console.log("mphase=",mphase);
    let murl = `https://www.youtube.com/watch?v=${mphase}`;
    //console.log("murl=",murl);

    window.open( murl, "_blank", "noopener,noreferrer");
  };


  const openInstaVideo = (mphase) => {
    //console.log("mphase =", mphase);

    const murl = `https://www.instagram.com/reel/${mphase}/`;
    //console.log("murl =", murl);

    openInstagramVideo(murl);
  };

  const openTikTokVideo = (mphase) => {
    //console.log("mphase =", mphase);

    const murl = `https://www.tiktok.com/@moonphasewizard/video/${mphase}`;
    //console.log("tiktok url =", murl);

    window.open(
       murl,"_blank", "noopener,noreferrer");
  };


const openInstagramVideo = (urlOrShortcode) => {
  // Extract the shortcode from a complete Instagram URL if necessary
  const shortcodeMatch = urlOrShortcode.match(
    /(?:p|reel)\/([A-Za-z0-9_-]+)/
  );

  const shortcode = shortcodeMatch
    ? shortcodeMatch[1]
    : urlOrShortcode.trim();

  const webUrl = `https://www.instagram.com/reel/${shortcode}/`;
  const isAndroid = /Android/i.test(navigator.userAgent);
  const isIPhone = /iPhone/i.test(navigator.userAgent);
  const ttchk = new URLSearchParams(window.location.search);
  const isTikTok = ttchk.get("source")?.toLowerCase() === "tiktok";

  if (isAndroid) {
    const intentUrl =
      `intent://www.instagram.com/reel/${shortcode}/` +
      `#Intent;scheme=https;package=com.instagram.android;` +
      `S.browser_fallback_url=${encodeURIComponent(webUrl)};end`;

    window.location.href = intentUrl;
  };

  if (isIPhone) {
    // Same-tab navigation is more reliable on iPhone.
    window.location.assign(webUrl);
  } else {
    window.open(webUrl, "_blank", "noopener,noreferrer");
  }
};

  const submitForm = (e) => {
    e.preventDefault();

    let gmtos = NOT_FOUND;
    if (gmtoff === NOT_FOUND) {
      if (lmt === true)  {
        gmtos = blong / 15.0;
      }
    } else {
      gmtos = parseFloat(gmtoff);
    }
    if (blat === NOT_FOUND || blong === NOT_FOUND || gmtos === NOT_FOUND) {
      let msg = (gmtos === NOT_FOUND) ? 'GMT Offset not found. LMT?' : 'Location not found';
      setMessage(msg);
      return;
    }

    const dateStr = `${bdate.current.value} ${btime.current.value}`;
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) {
      setMessage('Invalid Date');
      return;
    }

    // Extract date parts (no leading zeros)
    const year = date.getFullYear();
    const month = date.getMonth() + 1; // Months are 0-indexed
    const day = date.getDate();

    // Extract time parts (with leading zeros)
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    // Combine into the final string
    const dttm = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

    //console.log(dttm);
    // const dttm = fmtDttm2(bdate.current.value, btime.current.value);

    setJcal(false);
    let cal = false;

    let lsReg = localStorage.getItem('sgaRegister');

    const req = `"{"event":"moonphase-req","data":" { 'dttm': '${dttm}', 'timezone': ${gmtos}, 'longitude': ${blong}, 'latitude': ${blat}, 'city': '${titleCase(city)}', 'state': '${stctry.toUpperCase()}', 'author': '${lsReg}', 'sex': 'M', 'jcal': ${cal} }"}"`;

    sendReq({ msg: req });
    setMessage('');
  }

  const onLMTChange = (e) => {
    setLmt(e.target.checked);
    if ( e.target.checked ===  true &&
      blong !== 0){
        setGmtoff(blong / 15.0 );
      }
  }

  const onJCALChange = (e) => {
    setJcal(e.target.checked);
  }

  const onCityChange = (val) => {
    setCity(val);
  }

  const onStCtryChange = (val) => {
    setStctry(val);
  }

  const onBlongChange = (val) => {
    setBlong(val);
  }

  const onBlatChange = (val) => {
    setBlat(val);
  }

  const onGmtoffChange = (val) => {
    setGmtoff(val);
  }

  const onTabClick = (e) => {
    setSeltab(e.currentTarget.id);
  }

  return (
   <>
   <h1 style={{textAlign: 'center'}}>Find Your Moon Phase</h1>
   <div style={{ margin: '5px', fontWeight: 'bold' }}>
   <Form ref={eform} onSubmit={submitForm}>

     <Row className="mb-3">
       <Form.Group as={Col} style={{ gap: "2px" }} controlId="formBirthDate">
         <Form.Label>Birth Date</Form.Label>
         <Form.Control type="date" name='bdate' ref={bdate} onBlur={onBlur} placeholder="Birth Date" required />
       </Form.Group>

       <Form.Group as={Col} controlId="formBirthTime">
         <Form.Label>Birth Time</Form.Label>
         <Form.Control type="time" name='btime' ref={btime} onBlur={onBlur}
 	      placeholder="Birth Time" required />
       </Form.Group>
     </Row>

     <Row className="mb-3">
       <Form.Group as={Col} style={{gap: "2px"}} controlId="formCity">
         <Form.Label>City</Form.Label>
         <Form.Control name='city' onChange={e => onCityChange(e.target.value)}
             onBlur={onBlur} required maxLength="80"/>
       </Form.Group>

       <Form.Group as={Col} controlId="formState">
         <Form.Label>State</Form.Label>
         <Form.Control name='stctry' placeholder="Birth State"
            onChange={e => onStCtryChange(e.target.value)}
            onBlur={onBlur} required maxLength="30" />
       </Form.Group>
     </Row>

     <Row className="mb-3">
       <Form.Group as={Col} style={{gap: "2px"}} controlId="formLongitude">
         <Form.Label>Longitude</Form.Label>
         <Form.Control name='blong' onChange={e => onBlongChange(e.target.value)}
	    placeholder="Longtitude" value={blong} required/>
       </Form.Group>

       <Form.Group as={Col} controlId="formLatitude">
         <Form.Label>Latitude</Form.Label>
         <Form.Control name='blat' onChange={e => onBlatChange(e.target.value)}
            placeholder="Latitude" value={blat} required/>
       </Form.Group>
     </Row>

     <Row className="mb-3">
       <Form.Group as={Col} style={{gap: "2px"}} controlId="formGMToff">
         <Form.Label>GMT</Form.Label>
         <Form.Control name='gmtoff' onChange={e => onGmtoffChange(e.target.value)}
            value={gmtoff} required/>
       </Form.Group>

       <Form.Group as={Col} style={{gap: "2px", fontSize: "16px"}} controlId="formGender">
         <div className='nccontainer'>
	   <div>
	     <Form.Label for="lmt">LMT</Form.Label>&nbsp;
	     <input type="checkbox" name="lmt" id="lmt" onChange={onLMTChange}/>
	   </div>
           <div>
             <Form.Label for="jcal">JCAL</Form.Label>&nbsp;
             <input type="checkbox" name="jcal" id="jcal" onChange={onJCALChange}/>
           </div>
         </div>
       </Form.Group>
     </Row>

     <div style={{textAlign: 'center'}}>
  	<Button variant="primary" type="submit">Get Your Moon Phase</Button>
    </div>
    <div className="fRow ext-center">
       <span className='emsg'>{message}</span>
    </div>
   </Form>
  </div>

   </>
  );
}
